export function calculatePercentage(num, percent) {
  const number = Number(num);
  const percentage = Number(percent);

  return (number / 100) * percentage;
}
